export class PropertyInvalid<T> {
  constructor(
    public readonly object: T,
    public readonly propertyName: keyof T & string,
  ) {}
}
